/*
Extension of the Backbone Model to work better with Django-Tastypie

Based on http://paltman.com/2012/04/30/integration-backbonejs-tastypie/
*/
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.Model.extend({
  base_url: function () {
    var temp_url = Backbone.Model.prototype.url.call(this);
    return temp_url.charAt(temp_url.length - 1) === '/' ? temp_url : temp_url + '/';
  },
  url: function () {
    return this.base_url();
  },
  parse: function (data) {
    // Return the first entry in 'data.objects' if it exists and is an array, or else just plain 'data'.
    // from https://github.com/PaulUithol/backbone-tastypie/blob/master/backbone_tastypie/static/js/backbone-tastypie.js
    return data && data.objects && (_.isArray(data.objects) ? data.objects[0] : data.objects) || data;
  }
});



// WEBPACK FOOTER //
// ./static/js/models/tastypie.js